var _a;
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { Text } from '@doordash/design-language';
import Button from '@doordash/component-button';
import { JoinByInviteStrings } from './JoinByInviteStrings';
import { ERRORS } from './constants';
import { EXTERNAL_ROUTES, IDENTITY_SERVICE_POST_LOGOUT_PATH, PORTAL_ROUTE_PREFIX, } from '../../constants/values';
import { getLogoutUrl } from '../../utils/identity_helper';
import { useMediaQuery } from '../../core/Common/MediaQueryProvider';
import { JoinV2PageEvents } from '../../constants/events/names';
import track from '../../utils/track';
export var ERROR_CONTENT = (_a = {},
    _a[ERRORS.invalidInviteLink] = {
        title: JoinByInviteStrings.invalidInviteError.title(),
        body: JoinByInviteStrings.invalidInviteError.body(),
    },
    _a[ERRORS.somethingWentWrong] = {
        title: JoinByInviteStrings.somethingWentWrongError.title(),
        body: JoinByInviteStrings.somethingWentWrongError.body(),
        buttonText: JoinByInviteStrings.somethingWentWrongError.button(),
    },
    _a[ERRORS.useCompanyEmail] = {
        title: JoinByInviteStrings.useCompanyEmailError.title(),
        body: JoinByInviteStrings.useCompanyEmailError.body(),
        buttonText: JoinByInviteStrings.useCompanyEmailError.button(),
    },
    _a[ERRORS.tryADifferentAccount] = {
        title: JoinByInviteStrings.tryADifferentAccountError.title(),
        buttonText: JoinByInviteStrings.shared.anotherAccountButton(),
    },
    _a[ERRORS.existingMealBenefits] = {
        title: JoinByInviteStrings.existingMealBenefitsError.title(),
        buttonText: JoinByInviteStrings.shared.anotherAccountButton(),
        secorndaryButtonText: JoinByInviteStrings.existingMealBenefitsError.viewMyCurrentBenefitsButton(),
    },
    _a);
var JoinByInviteErrorPage = function (_a) {
    var errorType = _a.errorType, consumerEmail = _a.consumerEmail, errorMetadata = _a.errorMetadata;
    var isMobile = useMediaQuery().isMobile;
    var pendingMemberId = useParams().pendingMemberId;
    var _b = ERROR_CONTENT[errorType], title = _b.title, body = _b.body, buttonText = _b.buttonText, secorndaryButtonText = _b.secorndaryButtonText;
    var somethingWentWrongOnClickHandler = function () { return window.location.reload(); };
    var logoutUserAndRedirectBackToJoinPage = React.useCallback(function () {
        track(JoinV2PageEvents.WORK_PORTAL_JOIN_PAGE_V2_USE_ANOTHER_ACCOUNT_CLICK, {
            pending_member_id: pendingMemberId,
        });
        var postLogoutRedirectPath = IDENTITY_SERVICE_POST_LOGOUT_PATH + "/?state=" + PORTAL_ROUTE_PREFIX + "/join/" + pendingMemberId;
        window.location.href = getLogoutUrl(postLogoutRedirectPath);
    }, [pendingMemberId]);
    var viewCurrentMealBenefitsOnBenefitsPage = function () {
        window.location.href = EXTERNAL_ROUTES.BENEFITS_PAGE;
    };
    var getPrimaryButtonOnClickHanlderByErrorType = function () {
        switch (errorType) {
            case ERRORS.somethingWentWrong:
                return somethingWentWrongOnClickHandler();
            case ERRORS.existingMealBenefits:
                return logoutUserAndRedirectBackToJoinPage();
            case ERRORS.tryADifferentAccount:
                return logoutUserAndRedirectBackToJoinPage();
            case ERRORS.useCompanyEmail:
                return logoutUserAndRedirectBackToJoinPage();
            default:
                return null;
        }
    };
    var pageBody = React.useMemo(function () {
        var _a, _b;
        if (errorType) {
            switch (errorType) {
                case ERRORS.tryADifferentAccount:
                    return JoinByInviteStrings.tryADifferentAccountError.body((_a = errorMetadata === null || errorMetadata === void 0 ? void 0 : errorMetadata.existingInfo) === null || _a === void 0 ? void 0 : _a.teamName);
                case ERRORS.existingMealBenefits:
                    return JoinByInviteStrings.existingMealBenefitsError.body((_b = errorMetadata === null || errorMetadata === void 0 ? void 0 : errorMetadata.existingInfo) === null || _b === void 0 ? void 0 : _b.teamName);
                default:
                    return body;
            }
        }
        return '';
    }, [errorType, errorMetadata, body]);
    var secondaryPageBody = React.useMemo(function () {
        var _a;
        if (errorType) {
            switch (errorType) {
                case ERRORS.useCompanyEmail:
                    return JoinByInviteStrings.useCompanyEmailError.body2(consumerEmail);
                case ERRORS.existingMealBenefits:
                    return JoinByInviteStrings.existingMealBenefitsError.body2((_a = errorMetadata === null || errorMetadata === void 0 ? void 0 : errorMetadata.currentInfo) === null || _a === void 0 ? void 0 : _a.teamName);
                default:
                    return '';
            }
        }
        return '';
    }, [errorType, errorMetadata, consumerEmail]);
    var textAlignment = isMobile
        ? Text.TextAlignments.Left
        : Text.TextAlignments.Center;
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { styles: Text.Styles.PageTitle2, textAlign: textAlignment }, title),
        React.createElement(Text, { styles: Text.Styles.Body1, textAlign: textAlignment }, pageBody),
        secondaryPageBody && (React.createElement(Text, { styles: Text.Styles.Body1, textAlign: textAlignment }, secondaryPageBody)),
        buttonText && (React.createElement(Button, { type: Button.Types.Primary, onClick: getPrimaryButtonOnClickHanlderByErrorType }, buttonText)),
        secorndaryButtonText && (React.createElement(Button, { type: Button.Types.FlatSecondary, onClick: errorType === ERRORS.existingMealBenefits
                ? viewCurrentMealBenefitsOnBenefitsPage
                : null }, secorndaryButtonText))));
};
export default JoinByInviteErrorPage;
